module.exports = __webpack_public_path__ + "static/img/ousaisi.13a6577.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/ousaisi.png
// module id = 5krn
// module chunks = 1